export default __webpack_public_path__ + "static/media/lgn-laptop-main.65ebed68.webp";